const LBS_TO_KG_RATIO = 0.45359237;
const MONEY_CODES = {
  USD: '$',
  GBP: '£',
  AUD: 'A$',
  CAD: 'C$'
};
const WEIGHT_CODES = {
  lbs: 'pounds',
  kg: 'kilograms'
};

export function getCurrencySymbol(code) { return MONEY_CODES[code] || '$' }

export default class Site {
  convertWeightToKg(weight) {
    return weight * LBS_TO_KG_RATIO
  }

  convertWeightToLbs(weight) {
    return weight / LBS_TO_KG_RATIO
  }

  weightString(weightInLb, unit) {
    let result = (weightInLb || '0').toString().replace(',', '.');
    if (unit === 'kg') {
      result = this.convertWeightToKg(weightInLb).toFixed(2);
    }
    return `${result} ${unit}`;
  }

  convertedWeight(weightInLb, units) {
    let result = (weightInLb || '0').toString().replace(',', '.');
    if (units === 'kg') {
      result = this.convertWeightToKg(weightInLb);
    }
    return Math.round(result);
  }

  currency() {
    return this.currencyCode
  }

  getCurentWeightUnitText() {
    return WEIGHT_CODES[this.shortWeight];
  }

  getWeightUnitText(code) {
    return WEIGHT_CODES[code];
  }

  getShortWeight() {
    return this.shortWeight;
  }

  currentWeightString(value) {
    let result = value;
    if (this.getShortWeight() === 'kg') {
      result = this.convertWeightToKg(value).toFixed(2);
    }
    return `${result} ${this.getShortWeight()}`;
  }

  locationCode() {
    return this.siteCode;
  }

  moneySymbol() {
    return this.getSymbol(this.currencyCode);
  }

  // returns the given number with two decimals if it's float, else just the value
  twoDecimalsMoney(value) {
    let result = value * this.convertionRate;
    if (result % 1 !== 0) {
      result = result.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      result = result.toLocaleString('en-US');
    }

    return result;
  }

  toFixed(value, p) {
    let result = value * this.convertionRate;
    result = result.toLocaleString('en-US', { minimumFractionDigits: p, maximumFractionDigits: p });
    return this.moneySymbol() + result;
  }

  fullMoneyString(value) {
    return this.moneySymbol() + this.twoDecimalsMoney(value);
  }

  fullMoneyStringWithCurrency(currency, value) {
    return this.getSymbol(currency) + this.twoDecimalsMoney(value);
  }

  maxGoal() {
    return this.maxGoalValue;
  }

  minBetValue() {
    return this.minimumBetValue;
  }

  getSymbol(code) {
    return getCurrencySymbol(code)
  }

  showDisclaimer() {
    return this.isUkSite() || this.isAusSite() || this.isCadSite();
  }

  isUsSite() {
    return this.locationCode() === 'US';
  }

  isUkSite() {
    return this.locationCode() === 'UK'
  }

  isAusSite() {
    return this.locationCode() === 'AUS';
  }

  isCadSite() {
    return this.locationCode() === 'CAD';
  }

  getDisclaimerText() {
    return 'HealthyWage is an American company, and new to ' + this.siteName + '. In order to prevent reader confusion, we present our advertising and success stories with pounds translated to ' + this.getWeightUnitText(this.shortWeight) + ', and US Dollars translated to ' + this.moneyText;
  }

  goToUSSite() {
    window.location.replace(fullUrlForSite('www.healthywage.com'));
  }

  goToUKSite() {
    window.location.replace(fullUrlForSite('HealthyWage UK'));
  }

  goToAUSSite() {
    window.location.replace(fullUrlForSite('HealthyWage AUS'));
  }

  goToCADSite() {
    window.location.replace(fullUrlForSite('HealthyWage CAD'));
  }

  rateAbove(rate, units) {
    return units === 'kg' ? rate > 0.9 : rate > 2
  }

  rateEquals(rate, units) {
    return units === 'kg' ? (rate >= 0.4 && rate <= 0.9) : (rate >= 1 && rate <= 2)
  }

  rateBelow(rate, units) {
    return units === 'kg' ? rate < 0.4 : rate < 1
  }

  recommendedRate(units) {
    return units === 'kg' ? '0.4 - 0.9 kg' : '1-2 lbs'
  }

  cmsToFeet(value) {
    const inches = value / 2.54
    return parseInt(inches / 12)
  }

  cmsToInches(value) {
    const inches = value / 2.54
    return parseInt(inches % 12)
  }

  isDevelopment() {
    return window.location.hostname.includes('localhost') || window.location.hostname.includes('development.healthywage.com');
  }
}

function fullUrlForSite(siteName) {
  return `${window.location.protocol}//${window.healthywage.sites[siteName]}:${window.location.port}${window.location.pathname}${window.location.hash}`
}
